import FindDuplicates from './container/index'

export default FindDuplicates;


// WEBPACK FOOTER //
// ./src/components/page/FindDuplicates/index.js